import script from "./RecordView.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordView.vue?vue&type=script&setup=true&lang=js"

import "./RecordView.vue?vue&type=style&index=0&id=3e48837a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e48837a"]])

export default __exports__